import React, { useState, useEffect } from "react";
import CommonSection from "../components/CommonSection";
import { Container, Row, Col } from "reactstrap";
import Helmet from "../components/Helmet";
import Register from "../components/Register";
import BecomeDriverForm from "../components/BecomeDriverForm";
import "../styles/signup.css";
import MyCars from "../components/myCars";
import HostBookings from "../components/hostBookings";
import jwtDecode from "jwt-decode";
import { getHostTrips } from "../util/api";

const Blogs = () => {
  const [activeTab, setActiveTab] = useState("myCars");
  const [activeData, setActiveData] = useState([]);
  const [PendingData, setPendingData] = useState([]);
  const [scheduled, setScheduled] = useState([]);
  const [history, setHistory] = useState([]);
  useEffect(() => {
    getActive();
    getPending();
    getScheduled();
    getHistory();
  }, []);

  const getActive = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);

    getHostTrips(decoded.OwnerId, "active").then((res) => {
      if (res.message == "No Records Found") {
        setActiveData([]);
      } else {
        setActiveData(res);
      }
    });
  };

  const getPending = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);

    getHostTrips(decoded.OwnerId, "pending").then((res) => {
      if (res.message == "No Records Found") {
        setPendingData([]);
      } else {
        setPendingData(res);
      }
    });
  };
  const getScheduled = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);

    getHostTrips(decoded.OwnerId, "Booked").then((res) => {
      if (res.message == "No Records Found") {
        setScheduled([]);
      } else {
        setScheduled(res);
      }
    });
  };
  const getHistory = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);

    getHostTrips(decoded.OwnerId, "Completed").then((res) => {
      if (res.message == "No Records Found") {
        setHistory([]);
      } else {
        setHistory(res);
      }
    });
  };
  return (
    <Helmet title="Host">
      <section className="p-0">
        <CommonSection title="Host" />
      </section>
      <section className="pt-0">
        <Container>
          <Row>
            <Col lg="12" md="10" className="m-auto">
              {/* <h4 className="d-flex align-items-center gap-2 justify-content-center mb-5">
                <i class="ri-key-2-line"></i> Sign Up
              </h4> */}
              <div className=" mb-5 time__line d-flex align-items-center justify-content-between">
                <h6
                  className={` ${
                    activeTab === "myCars" ? "active2" : ""
                  }  line`}
                  onClick={() => setActiveTab("myCars")}
                >
                  <span
                    className={` ${activeTab === "myCars" ? "active" : ""}  `}
                    onClick={() => setActiveTab("myCars")}
                  >
                    1
                  </span>{" "}
                  My cars
                </h6>

                <h6
                  className={` ${activeTab === "active" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("active")}
                >
                  <span
                    className={` ${
                      activeTab === "active" ? "active" : ""
                    } me-1 `}
                    onClick={() => setActiveTab("active")}
                  >
                    2
                  </span>
                  Active Bookings
                </h6>
                <h6
                  className={` ${activeTab === "pending" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("pending")}
                >
                  <span
                    className={` ${
                      activeTab === "pending" ? "active" : ""
                    } me-1 `}
                    onClick={() => setActiveTab("pending")}
                  >
                    3
                  </span>
                  Pending Bookings
                </h6>
                <h6
                  className={` ${activeTab === "scheduled" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("scheduled")}
                >
                  <span
                    className={` ${
                      activeTab === "scheduled" ? "active" : ""
                    } me-1 `}
                    onClick={() => setActiveTab("scheduled")}
                  >
                    4
                  </span>
                  Scheduled
                </h6>
                <h6
                  className={` ${activeTab === "history" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("history")}
                >
                  <span
                    className={` ${
                      activeTab === "history" ? "active" : ""
                    } me-1 `}
                    onClick={() => setActiveTab("history")}
                  >
                    5
                  </span>
                  History
                </h6>
              </div>

              {/* <Register /> */}

              {activeTab === "myCars" ? <MyCars /> : null}
              {activeTab === "active" ? (
                <HostBookings data={activeData} />
              ) : null}
              {activeTab === "pending" ? (
                <HostBookings data={PendingData} />
              ) : null}
              {activeTab === "scheduled" ? (
                <HostBookings data={scheduled} />
              ) : null}
              {activeTab === "history" ? <HostBookings data={history} /> : null}
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Blogs;
